// GENERATED by store-ksp from @StoreProvider. DO NOT EDIT — this is a build
// artifact, not committed source. Change the annotation on the provider instead.

package kpt.core.store.config

import kpt.core.base.store.infra.StoreRegistry
import kotlin.time.Duration.Companion.days
import kotlin.time.Duration.Companion.hours
import kotlin.time.Duration.Companion.minutes

/**
 * Every Store5 qualifier the app exposes, and the freshness window of each store that
 * declares one. Derived from `@StoreProvider`.
 */
object AppStoreRegistry : StoreRegistry() {
    val Alerts = store("alerts")
    val AlertsMutable = store("alertsMutable")
    val AmortizationCalc = store("amortizationCalc")
    val BillReminders = store("billReminders")
    val BillRemindersMutable = store("billRemindersMutable")
    val CloudTodo = store("cloudTodo")
    val CloudTodoMutable = store("cloudTodoMutable")
    val CoinDetail = store("coinDetail")
    val CoinMarkets = store("coinMarkets")
    val Emi = store("emi")
    val ExchangeRates = store("exchangeRates")
    val InterestRateSeries = store("interestRateSeries")
    val Loans = store("loans")
    val LoansMutable = store("loansMutable")
    val MacroIndicator = store("macroIndicator")
    val Profile = store("profile")
    val RateHistory = store("rateHistory")
    val SpotRate = store("spotRate")
    val UserData = store("userData")
    val Watchlist = store("watchlist")
    val WatchlistMutable = store("watchlistMutable")

    /** Freshness windows, declared as `@StoreProvider(ttl = …)`. */
    object Ttl {
        val COIN_DETAIL = 5.minutes
        val COIN_MARKETS = 2.minutes
        val EXCHANGE_RATES = 5.minutes
        val INTEREST_RATE_SERIES = 24.hours
        val MACRO_INDICATOR = 7.days
        val RATE_HISTORY = 1.hours
    }
}
